import { NextPage } from 'next';
import { Banner, CasesGrid } from '@/components/screens';
import { CasesGridMobile } from '@/components/screens/cases/casesGridMobile';

const CasesPage: NextPage = () => {
	return (
		<>
			<Banner withBackButton />
			<CasesGrid className="hidden sm:block pb-[100px]" />
			<CasesGridMobile />
		</>
	);
};

export default CasesPage;
